import { render, staticRenderFns } from "./FormBuilderFurtherActionReport.vue?vue&type=template&id=20f26830&"
import script from "./FormBuilderFurtherActionReport.vue?vue&type=script&lang=js&"
export * from "./FormBuilderFurtherActionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports